import { enableProdMode } from '@angular/core';
import { platformBrowser, REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const providers = [
  { provide: REMOVE_STYLES_ON_COMPONENT_DESTROY, useValue: true } // angular 17 - I'm pretty sure we rely on leaked styles
];

if (environment.production) {
  enableProdMode();
}

platformBrowser(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
